import React from 'react';
import { Carousel, Button } from 'react-bootstrap';

function Home() {

    return (
        <React.Fragment>
            <section className='inicio'>


                <h1><span className='logo'>&nbsp;TU&nbsp;</span>SALUD <br /> <span className='subtitle'>Mejora tu salud por medio de alimentación y ejercicio</span></h1>


            </section>

            <section className='resumen'>
                <div className='frutas'></div>
                <div className='verduras'></div>
                <div className='pesas'></div>

                <div className='title-center'>

                    <h2>La importancia de comer sano y hacer ejercicio</h2>

                    <p>El ejercício y la dieta saludable pueden ayudarte a tener una vida más variada e interesante.
                        Busca formas creativas de mantenerte activo físicamente en tu vida diaria,
                        y no hagas siempre la misma rutina de ejercicio. Haz ejercicios con tus compañeros de trabajo,
                        puedes salir a bailar con amigos, forma parte de equipos de deportes y pasa tiempo con tus hijos y los miembros de tu familia.
                        Mantener una dieta saludable puede brindar oportunidades para concinar en casa, tomar clase de cocina,
                        visitar las granjas y hacer todo tipo de actividades divertidad.</p>
                </div>


                <div className='nota'>
                    <div className='nota-imagen nota-peso'> </div>
                    <div className='nota-texto'>
                        <p><strong>Peso</strong></p>
                        <p>Si tienes sobrepeso, comer de manera saludable y hacer ejercicios regularmente puede ayudarte a perder peso de forma segura y
                            a no recuperarlo. Si no tienes problema de peso, la actividad física y una dieta saludable te pueden ayudar a mentener tu peso actual y
                            reducir los riesgos de aumentar de peso a medida que envejeces. La comida saludable, por lo general, es baja en calorías y
                            alta en nutrientes en comparación con otras comidas, y
                            el ejercicio físico regular quema las calorías extras para mantener un físico saludable.</p>
                    </div>
                </div>

                <div className='nota'>
                    <div className='nota-imagen nota-energia'> </div>
                    <div className='nota-texto'>
                        <p><strong>Energía</strong></p>
                        <p>La combinación de ejercício y comida saludable puede ayudarte a incrementar tu nivel de energía y
                            a sentirte más alerta y consciente, tanto mental como físicamente. La comida saludable le da a tu  cuerpo los nutrientes y
                            las vitaminas que necesita para alcanzar su máximo potencial.</p>
                    </div>
                </div>

                <div className='nota'>
                    <div className='nota-imagen nota-animo'> </div>
                    <div className='nota-texto'>
                        <p><strong>Ánimo</strong></p>
                        <p> El ejercício estimula los químicos del cerebro que ayudan a generar sentimientos de felicidad,
                            satisfacción y relajación, por lo que te sentirás mejor si haces ejercicio regularmente.
                            La actividad física también puede favorecer tu aspecto, ya que cuando hacer ejercicio quemas grasas y
                            tonificas los músculos, lo cual es un factor determinante a la hora de aumentar el autoestima y
                            sentirse satisfecho con la vida.</p>
                    </div>
                </div>

                <div className='title-center'>
                    <p>
                        Centro medico ciudad jardin, La importancia de comer sano y hacer ejercicio <br /> https://www.centromedicociudadjardin.com/la-importancia-de-comer-sano-y-hacer-ejercicio.html
                    </p>
                </div>


            </section>

            <section>

                <Carousel fade>
                    <Carousel.Item>
                        <img
                            className="d-block w-100"
                            src="https://images.pexels.com/photos/4884210/pexels-photo-4884210.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                            alt="First slide"
                            height="300"
                        />
                        <Carousel.Caption>
                            <h5>Organización Mundial de la Salud.</h5>
                            <p>Información actualizada sobre la salud a nivel mundial.</p>
                            <Button href="https://www.who.int/es" target="_blank" variant="outline-info">Ir a la pagina</Button>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="d-block w-100"
                            src="https://images.pexels.com/photos/4852733/pexels-photo-4852733.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                            alt="Second slide"
                            height="300"
                        />
                        <Carousel.Caption>
                            <h5>DEPORTE y VIDA</h5>
                            <p>Información de alta relevancia para la salud alimentaria y física.</p>
                            <Button href="https://as.com/deporteyvida/tag/salud/a/" target="_blank" variant="outline-info">Ir a la pagina</Button>
                        </Carousel.Caption>
                    </Carousel.Item>
                    <Carousel.Item>
                        <img
                            className="d-block w-100"
                            src="https://images.pexels.com/photos/5738083/pexels-photo-5738083.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                            alt="Third slide"
                            height="300"
                        />
                        <Carousel.Caption>
                            <h5>Escuela de nutrición</h5>
                            <p>ENu escuela de nutrición de la universidad de Costa Rica.</p>
                            <Button href="https://nutricion.ucr.ac.cr/index.php/es/12-news" target="_blank" variant="outline-info">Ir a la pagina</Button>
                        </Carousel.Caption>
                    </Carousel.Item>
                </Carousel>

            </section>
        </React.Fragment>
    );


}
export default Home;